import { Table, TableBody, TableHead, TablePagination } from "@mui/material";
import React from "react";

import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "@/constants/pagination";
import IProductVariation from "@/interfaces/variation.interface";
import { VariationsTableMessages } from "@/messages/variation/variations-table.messages";
import { Pagination } from "@/types/page.types";
import { PaginatedResponse } from "@/types/requests.types";

import { Row } from "./row";
import { VARIATIONS_TABLE_COLUMNS } from "../../constants";

interface ProductVariationTableProps {
  data: PaginatedResponse<IProductVariation>;
  pagination: Pagination;
  messages: VariationsTableMessages;
}

export function ProductVariationTable({ data, pagination, messages }: ProductVariationTableProps) {
  return (
    <>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableHeaderRow>
              {VARIATIONS_TABLE_COLUMNS(messages).map((label, index) => (
                <HeaderTableCell key={`${index} - ${label}`}>{label}</HeaderTableCell>
              ))}
            </TableHeaderRow>
          </TableHead>
          <TableBody>
            {data.items &&
              data.items.map((variation, index) => {
                return (
                  <Row
                    key={`${index} - ${variation.code}`}
                    variation={variation}
                    index={index}
                    messages={messages}
                  />
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        labelRowsPerPage={messages.rowsPerPage}
        rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        component="div"
        count={data.totalCount}
        onRowsPerPageChange={(e) => pagination.extend(Number(e.target.value))}
        rowsPerPage={pagination.pageSize}
        page={pagination.pageNumber - 1}
        onPageChange={(_, pageNumber) => pagination.changePage(pageNumber)}
      />
    </>
  );
}
